<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
    bank: String,
    id: String,
    icon: String,
    edit: Object,
    darkmode: Boolean
});

const { t } = useI18n();
const emit = defineEmits(['edit','archive','delete']);

</script>

<template>
    <div class="account-row-premium">

        <div class="account-row-left">
            <div class="account-row-icon">
                <img :src="icon" alt="">
            </div>

            <div class="account-row-info">
                <strong>{{ bank }}</strong>
                <span v-if="edit.archived == 'Yes'">Arquivada</span>
            </div>
        </div>

        <div class="account-row-actions">

            <button v-if="edit.archived == 'No'"
                @click="$emit('edit', edit)"
                data-bs-toggle="modal"
                data-bs-target="#addAccount"
                class="account-row-btn"
            >
                <i class="fal fa-pencil"></i>
            </button>

            <button v-if="edit.archived == 'No'"
                @click="$emit('archive', edit, 'Yes')"
                class="account-row-btn"
            >
                <i class="fal fa-inbox-in"></i>
            </button>

            <button v-if="edit.archived == 'Yes'"
                @click="$emit('archive', edit, 'No')"
                class="account-row-btn"
            >
                <i class="fal fa-inbox-out"></i>
            </button>

            <button v-if="edit.archived == 'Yes'"
                @click="$emit('delete', edit)"
                class="account-row-btn danger"
            >
                <i class="fal fa-trash"></i>
            </button>

        </div>

    </div>
</template>

<style>
.account-row-premium{
    display:flex;
    align-items:center;
    justify-content:space-between;
    padding:12px 14px;
    border-radius:16px;
    transition:.2s;
}

.account-row-premium:hover{
    background:rgba(0,0,0,0.03);
}

.account-row-left{
    display:flex;
    align-items:center;
    gap:12px;
}

.account-row-icon{
    width:46px;
    height:46px;
    border-radius:14px;
    background:#fff;
    display:flex;
    align-items:center;
    justify-content:center;
    box-shadow:0 4px 12px rgba(0,0,0,0.08);
}

.account-row-icon img{
    width:70%;
}

.account-row-info strong{
    display:block;
    color:#213E60;
}

.account-row-info span{
    font-size:12px;
    color:#8a9bb5;
}

.account-row-actions{
    display:flex;
    gap:8px;
}

.account-row-btn{
    width:36px;
    height:36px;
    border-radius:10px;
    border:none;
    background:#f1f5f9;
    display:flex;
    align-items:center;
    justify-content:center;
    transition:.2s;
}

.account-row-btn:hover{
    background:#e2e8f0;
    transform:translateY(-1px);
}

.account-row-btn.danger{
    background:#fee2e2;
    color:#ef4444;
}
</style>
